export default {
  'nicknames.accountNameChanged': 'Account name changed',
  'nicknames.assignAccountNickname': 'Assign Account Nickname',
  'nicknames.assignNickname': 'Assign Nickname',
  'nicknames.defaultName': 'Default name',
  'nicknames.editNickname': 'Edit Nickname',
  'nicknames.nicknameAlreadySetTo': 'Nickname already set to <%=value%>',
  'nicknames.placeholder': 'Enter Nickname',
  'nicknames.resetToDefault': 'Reset to default',
  'nicknames.to': 'to',
  'nicknames.updateDidNotWork': 'Update did not work',
  'nicknames.youAreAboutToRename': 'You are about to rename '
};
